<template>  
  <footer class="footer position-absolute bottom-2 py-2 w-100">
    <div class="container">
        <div class="row align-items-center justify-content-lg-between">
            <div class="col-12 col-md-6 my-auto">
                <div class="copyright text-center text-sm text-green text-lg-start">
                    © {{ new Date().getFullYear() }}
                    <a href="https://www.bluebased.nl" class="font-weight-bold text-green" target="_blank">BlueBased BV</a>
                </div>
            </div>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AuthFooter",
};
</script>
<style scoped>
.text-green {
    color: #0f8d09;
}
</style>